export default __webpack_public_path__ + "static/media/catalyst-day-1.d389ff03.svg";